import { Navigate, useLocation } from "react-router-dom";
import { useIsMobileViewport } from "@/hooks/useIsMobileViewport";
import { resolveDesktopPath, resolveMobilePath } from "@/mobile/viewportPaths";

/**
 * Redireciona entre rotas web e /m/* conforme a largura da viewport.
 * Celular → UI mobile; desktop → UI web (quando há equivalente).
 */
export function ViewportRedirect() {
  const isMobile = useIsMobileViewport();
  const location = useLocation();

  const target = isMobile
    ? resolveMobilePath(location.pathname)
    : resolveDesktopPath(location.pathname);

  if (!target || target === location.pathname) {
    return null;
  }

  return (
    <Navigate
      to={`${target}${location.search}${location.hash}`}
      replace
      state={location.state}
    />
  );
}
